import { useTranslation } from 'react-i18next';

import { Box, Divider, HStack, Switch, Text } from '@bonusly/design-system';

import { useReduceBizyMotionPreference } from '../bizy';

export const MotionSection = () => {
	const { t } = useTranslation('admin_bizy', { keyPrefix: 'settingsPanel.motion' });
	const [reduceBizyMotion, setReduceBizyMotion] = useReduceBizyMotionPreference();

	return (
		<>
			<Divider />
			<Box>
				<Text fontSize="sm" fontWeight="semibold" color="text.default" mb={2}>
					{t('title')}
				</Text>
				<HStack spacing={3} align="center" justify="space-between">
					<Box>
						<Text fontSize="sm" color="text.default" fontWeight="medium">
							{t('reduceMotionLabel')}
						</Text>
						<Text fontSize="xs" color="text.softer" mt={1}>
							{t('reduceMotionDescription')}
						</Text>
					</Box>
					<Switch
						aria-label={t('reduceMotionAriaLabel')}
						isChecked={reduceBizyMotion}
						onChange={(event) => setReduceBizyMotion(event.target.checked)}
						flexShrink={0}
					/>
				</HStack>
			</Box>
		</>
	);
};
